import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "./App";
import Congratulations from "./pages/Congratulations";
import FinalScene from "./pages/FinalScene";
import Gameover from "./pages/Gameover";
import Home from "./pages/Home";
import EnterCode from "./pages/EnterCode";
import Register from "./pages/Register";
import Presentation from "./pages/Presentation";
import Results from "./pages/Results";
import Scenario1Instructions from "./pages/Scenario1/Scenario1Instructions";
import Scenario1Intro from "./pages/Scenario1/Scenario1Intro";
import Scenario2Intro from "./pages/Scenario2/Scenario2Intro";
import Scenario2 from "./pages/Scenario2/Scenario2";
import Scenario2Intro2 from "./pages/Scenario2/Scenario2Intro2";
import Scenario2ResultadoPetCt from "./pages/Scenario2/Scenario2ResultadoPetCt";
import Scenario2Retroalimentacion from "./pages/Scenario2/Scenario2Retroalimentacion";
import Scenario2Clasificacion from "./pages/Scenario2/Scenario2Clasificacion";
import Scenario2AltoVolumen from "./pages/Scenario2/Scenario2AltoVolumen";
import Scenario2Metastasis from "./pages/Scenario2/Scenario2Metastasis";
import Scenario2Mujer from "./pages/Scenario2/Scenario2Mujer";
import Scenario2Fin from "./pages/Scenario2/Scenario2Fin";
import Scenario3Intro from "./pages/Scenario3/Scenario3Intro";
import Scenario3 from "./pages/Scenario3/Scenario3";
import Scenario3FinalOsResults from "./pages/Scenario3/Scenario3FinalOsResults";
import Scenario3PeaceI from "./pages/Scenario3/Scenario3PeaceI";
import Scenario3Antecedentes from "./pages/Scenario3/Scenario3Antecedentes";
import Scenario3Evaluacion from "./pages/Scenario3/Scenario3Evaluacion";
import Scenario3PistaEvaluacionGeriatricos from "./pages/Scenario3/Scenario3PistaEvaluacionGeriatricos";
import Scenario3EvaluacionGeriatricos from "./pages/Scenario3/Scenario3EvaluacionGeriatricos";
import Scenario3EscalaGeriatrica from "./pages/Scenario3/Scenario3EscalaGeriatrica";
import Scenario3Retroalimentacion from "./pages/Scenario3/Scenario3Retroalimentacion";
import Scenario3Fin from "./pages/Scenario3/Scenario3Fin";
import Scenario3Fin2 from "./pages/Scenario3/Scenario3Fin2";
import Scenario4Intro from "./pages/Scenario4/Scenario4Intro";
import Scenario4 from "./pages/Scenario4/Scenario4";
import Scenario4SuspensionTratamiento from "./pages/Scenario4/Scenario4SuspensionTratamiento";
import Scenario4Retroalimentacion from "./pages/Scenario4/Scenario4Retroalimentacion";
import Scenario4Radioterapia from "./pages/Scenario4/Scenario4Radioterapia";
import Scenario4Fin from "./pages/Scenario4/Scenario4Fin";
import Scenario5Intro from "./pages/Scenario5/Scenario5Intro";
import Scenario5 from "./pages/Scenario5/Scenario5";
import Scenario5Apalutamida from "./pages/Scenario5/Scenario5Apalutamida";
import Scenario5Retroalimentacion from "./pages/Scenario5/Scenario5Retroalimentacion";
import Scenario5Impacto from "./pages/Scenario5/Scenario5Impacto";
import Scenario5Conclusion from "./pages/Scenario5/Scenario5Conclusion";
import Scenario5Resultados from "./pages/Scenario5/Scenario5Resultados";
import Scenario5Fin from "./pages/Scenario5/Scenario5Fin";
import StartGame from "./pages/StartGame";
import StartGame2 from "./pages/StartGame2";
import StartGame3 from "./pages/StartGame3";
import StartGame4 from "./pages/StartGame4";
import StartGame5 from "./pages/StartGame5";
import Supertest from "./pages/Supertest/Supertest";
import SupertestInstructions from "./pages/Supertest/SupertestInstructions";
import SupertestIntro from "./pages/Supertest/SupertestIntro";
import TransitionScenarios from "./pages/TransitionScenarios";
import { ROUTES } from "./utils/constants";


import WarmupPage from "./pages/WarmupPage";
import EscapeRoomPlay from "./pages/EscapeRoomPlay";

export default function Rutas() {
	const isRegistered = useSelector((state) => state.group, shallowEqual);

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<App />}>
					<Route path="/" element={<Home />} />
					<Route path={ROUTES.ENTER_CODE} element={<EnterCode />} />
					<Route path={ROUTES.REGISTER} element={<Register />} />

							<Route path="warmup" element={<WarmupPage />} />
					
					{!isRegistered ? (
						<>
							{/* Permite entrar al flujo ER antes de registro si la primera página no es registration */}
							<Route
								path={ROUTES.ESCAPE_ROOM}
								element={<EscapeRoomPlay />}
							/>
							{/* Render register page when not registered. */}
							<Route path="*" element={<Navigate to={ROUTES.ENTER_CODE} replace />} />
						</>
					) : (
						<Route>
							<Route
								path={ROUTES.PRESENTATION}
								element={<Presentation />}
							/>
							<Route
								path={ROUTES.ESCAPE_ROOM}
								element={<EscapeRoomPlay />}
							/>
							<Route
								path={ROUTES.START_GAME}
								element={<StartGame />}
							/>
							<Route
								path={ROUTES.START_GAME2}
								element={<StartGame2 />}
							/>
							<Route
								path={ROUTES.START_GAME3}
								element={<StartGame3 />}
							/>
							<Route
								path={ROUTES.START_GAME4}
								element={<StartGame4 />}
							/>
							<Route
								path={ROUTES.START_GAME5}
								element={<StartGame5 />}
							/>
							<Route
								path={ROUTES.TRANSITION_SCENARIOS}
								element={<TransitionScenarios />}
							/>

							{/*Scenario 1*/}
							<Route
								path={ROUTES.SCENARIO1_INTRO}
								element={<Scenario1Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO1_INSTRUCTIONS}
								element={<Scenario1Instructions />}
							/>

							{/*Scenario 2*/}
							<Route
								path={ROUTES.SCENARIO2_INTRO}
								element={<Scenario2Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO2}
								element={<Scenario2 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_INTRO2}
								element={<Scenario2Intro2 />}
							/>
							<Route
								path={ROUTES.SCENARIO2_RESULTADOPETCT}
								element={<Scenario2ResultadoPetCt />}
							/>
							<Route
								path={ROUTES.SCENARIO2_RETROALIMENTACION}
								element={<Scenario2Retroalimentacion />}
							/>
							<Route
								path={ROUTES.SCENARIO2_CLASIFICACION}
								element={<Scenario2Clasificacion />}
							/>
							<Route
								path={ROUTES.SCENARIO2_ALTOVOLUMEN}
								element={<Scenario2AltoVolumen />}
							/>
							<Route
								path={ROUTES.SCENARIO2_METASTASIS}
								element={<Scenario2Metastasis />}
							/>
							<Route
								path={ROUTES.SCENARIO2_MUJER}
								element={<Scenario2Mujer />}
							/>
							<Route
								path={ROUTES.SCENARIO2_FIN}
								element={<Scenario2Fin />}
							/>

							{/*Scenario 3*/}
							<Route
								path={ROUTES.SCENARIO3_INTRO}
								element={<Scenario3Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO3}
								element={<Scenario3 />}
							/>
							<Route
								path={ROUTES.SCENARIO3_FINALOSRESULTS}
								element={<Scenario3FinalOsResults />}
							/>
							<Route
								path={ROUTES.SCENARIO3_PEACEI}
								element={<Scenario3PeaceI />}
							/>
							<Route
								path={ROUTES.SCENARIO3_ANTECEDENTES}
								element={<Scenario3Antecedentes />}
							/>
							<Route
								path={ROUTES.SCENARIO3_EVALUACION}
								element={<Scenario3Evaluacion />}
							/>
							<Route
								path={ROUTES.SCENARIO3_PISTAEVALUACIONGERIATRICOS}
								element={<Scenario3PistaEvaluacionGeriatricos />}
							/>
							<Route
								path={ROUTES.SCENARIO3_EVALUACIONGERIATRICOS}
								element={<Scenario3EvaluacionGeriatricos />}
							/>
							<Route
								path={ROUTES.SCENARIO3_ESCALAGERIATRICA}
								element={<Scenario3EscalaGeriatrica />}
							/>
							<Route
								path={ROUTES.SCENARIO3_RETROALIMENTACION}
								element={<Scenario3Retroalimentacion />}
							/>
							<Route
								path={ROUTES.SCENARIO3_FIN}
								element={<Scenario3Fin />}
							/>
							<Route
								path={ROUTES.SCENARIO3_FIN2}
								element={<Scenario3Fin2 />}
							/>

							{/*Scenario 4*/}
							<Route
								path={ROUTES.SCENARIO4_INTRO}
								element={<Scenario4Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO4}
								element={<Scenario4 />}
							/>
							<Route
								path={ROUTES.SCENARIO4_SUSPENSIONTRATAMIENTO}
								element={<Scenario4SuspensionTratamiento />}
							/>
							<Route
								path={ROUTES.SCENARIO4_RETROALIMENTACION}
								element={<Scenario4Retroalimentacion />}
							/>
							<Route
								path={ROUTES.SCENARIO4_RADIOTERAPIA}
								element={<Scenario4Radioterapia />}
							/>
							<Route
								path={ROUTES.SCENARIO4_FIN}
								element={<Scenario4Fin />}
							/>

							{/*Scenario 5*/}
							<Route
								path={ROUTES.SCENARIO5_INTRO}
								element={<Scenario5Intro />}
							/>
							<Route
								path={ROUTES.SCENARIO5}
								element={<Scenario5 />}
							/>
							<Route
								path={ROUTES.SCENARIO5_APALUTAMIDA}
								element={<Scenario5Apalutamida />}
							/>
							<Route
								path={ROUTES.SCENARIO5_RETROALIMENTACION}
								element={<Scenario5Retroalimentacion />}
							/>
							<Route
								path={ROUTES.SCENARIO5_IMPACTO}
								element={<Scenario5Impacto />}
							/>
							<Route
								path={ROUTES.SCENARIO5_CONCLUSION}
								element={<Scenario5Conclusion />}
							/>
							<Route
								path={ROUTES.SCENARIO5_RESULTADOS}
								element={<Scenario5Resultados />}
							/>
							<Route
								path={ROUTES.SCENARIO5_FIN}
								element={<Scenario5Fin />}
							/>

							{/*Supertest */}
							<Route
								path={ROUTES.SUPERTEST_INTRO}
								element={<SupertestIntro />}
							/>
							<Route
								path={ROUTES.SUPERTEST_INSTRUCTIONS}
								element={<SupertestInstructions />}
							/>
							<Route
								path={ROUTES.SUPERTEST}
								element={<Supertest />}
							/>
							<Route
								path={ROUTES.SUPERTEST_2}
								element={<Supertest />}
							/>
							<Route
								path={ROUTES.SUPERTEST_3}
								element={<Supertest />}
							/>
							<Route
								path={ROUTES.FINAL_SCENE}
								element={<FinalScene />}
							/>
							<Route
								path={ROUTES.CONGRATULATIONS}
								element={<Congratulations />}
							/>
							<Route
								path={ROUTES.RESULTS}
								element={<Results />}
							/>
							<Route
								path={ROUTES.GAMEOVER}
								element={<Gameover />}
							/>
						</Route>
					)}
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
